<div
  class="sidenav hide"
  #sidenavEl
  *ngIf="opened"
  [class]="class"
  [ngClass]="{
    'sidenav-android': DeviceHelper.isAndroid
  }"
>
  <div
    id="sidenav-popup"
    class="sidenav-popup {{ 'sidenav-popup-side-' + side }} out"
    #sidenavPopup
    [ngClass]="{
      'sidenav-popup-side-fullwidth': !!maxWidth() || isTaskSidenavExpandedWidth
    }"
    [ngStyle]="{ width: popupWidth(), 'max-width': popupWidth() }"
  >
    <div class="sidenav-popup-content">
      <ng-container #sidenavContent></ng-container>
    </div>
  </div>
  <div *ngIf="!hideBackdrop" class="sidenav-backdrop" (click)="closeBackdrop()"></div>
</div>
